import { useDarkSwitch } from "use-dark-switch";
import { useEffect } from "react";

export default function DarkModeToggle() {
  const { isDark, toggle } = useDarkSwitch();

  useEffect(() => {
    document.documentElement.classList.toggle("dark", isDark);
  }, [isDark]);

  return (
    <div className="flex flex-col items-center">
      <button
        onClick={toggle}
        className={`w-16 h-8 rounded-full p-1 transition-colors duration-200 ease-in-out ${
          isDark ? "bg-blue-600" : "bg-gray-300"
        }`}
      >
        <div
          className={`w-6 h-6 rounded-full transition-transform duration-200 ease-in-out ${
            isDark ? "translate-x-8 bg-white" : "translate-x-0 bg-white"
          }`}
        >
          {isDark ? "🌙" : "☀️"}
        </div>
      </button>
      <p className="mt-4 text-lg font-medium text-gray-800 dark:text-white">
        Current mode: {isDark ? "Dark" : "Light"}
      </p>
    </div>
  );
}
